<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Edit Press Release</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/tonepress" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="updatePress" v-if="press">
                <div class="row justify-content-md-center">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-4" v-if="contentOrder.length">
                        <fg-select
                          v-model="press.contentOrder"
                          label="Release Type"
                          v-validate="rules.active"
                          data-vv-name="Release Type"
                          cus-name="Release Type"
                          :has-errors="errors"
                          :is-fields="fields"
                          :list="contentOrder"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                      <div class="col-4">
                        <fg-input type="text"
                                  v-model="press.topicSubHead"
                                  label="Heading"
                                  placeholder="Enter Heading"
                                  v-validate="rules.topicSubHead"
                                  data-vv-name="Heading"
                                  cus-name="Heading"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-4">
                        <label>Published Date</label>
                        <datetime v-model="publishDate"
                                  required
                                  input-class="form-control"
                                  label="Published Date"
                                  placeholder="Select Date"
                                  type="date"
                                  input-format="DD-MM-YYYY"
                                  auto-continue>
                        </datetime>
                      </div>
                      <div class="col-12">
                        <fg-input type="text"
                                  v-model="press.topicSubHeadContents"
                                  label="Description"
                                  placeholder="Enter Description"
                                  v-validate="rules.topicSubHeadContents"
                                  data-vv-name="Description"
                                  cus-name="Description"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-9">
                        <fg-input type="text"
                                  v-model="press.pdfUrl"
                                  label="Link URL"
                                  placeholder="Enter URL"
                                  v-validate="rules.pdfUrl"
                                  data-vv-name="Link URL"
                                  cus-name="Link URL"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-3" v-if="status.length">
                        <fg-select
                          v-model="press.active"
                          label="Status"
                          v-validate="rules.active"
                          data-vv-name="active"
                          cus-name="active"
                          :has-errors="errors"
                          :is-fields="fields"
                          :list="status"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                    </div>
                  </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Update Press Release
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { imageHelpers } from '../../../../helpers/lambda'
    import moment from 'moment'
    export default {
        name: 'EditPress',
        created (){
        this.$store.dispatch('GETSELECTEDPRESS', this.$route.params.id).then(() =>{
            this.press = this.selectedPress;
            this.publishDate = new Date(this.press.topicSubHeadDate).toISOString();
        })
    },
    data () {
        let dateTime = new Date();
        return {
            publishDate: dateTime.toISOString(),
            press: this.selectedPress || {},
          rules: {
            contentOrder: {required : true},
            topicSubHead: {required : true},
            topicSubHeadContents: {required : true},
            pdfUrl: {required : true},
            active: {required: true}
          },
          status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
          contentOrder: [{id:"2", name:'Press Release'}, {id:"3", name:'In the News'}]
        }
    },
    methods: {
        updatePress () {
          this.press.topicSubHeadDate =  moment(this.publishDate).format('MM/DD/YYYY');
          this.$validator.validateAll().then((result) => {
            if(result){
              let updatePress = () =>{
                this.$store.dispatch('UPDATE_PRESSRELEASE', this.press)
                  .then((res) => {
                    console.log("UPDATE_EVENT res : ", res);
                    this.showPopup('Success!', 'Press is successfully updated', 'success', ()=>this.$router.push('/admin/tonepress'))

                  })
                  .catch(err => {
                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                    console.log("UPDATE_PRESS API error : ", err);
                  })
              };
              updatePress();
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    computed: {...mapGetters([
        'press', 'selectedPress']) }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Press/EditPress.vue